<template>
  <div class="flex flex-col gap-y-4 gap-x-8 justify-center items-center sm:flex-row sm:items-center">
    <h1 class="flex gap-x-2 text-base leading-7 capitalize">
      <template v-for="(routeVal, index) in currentRouteSegment">
        <span v-if="index === currentRouteSegment.length - 1" class="font-semibold">{{ routeVal }}</span>
        <div
          v-else
          class="font-semibold cursor-pointer hover:text-red-600"
          @click="onClickRoute(routeVal, `/${currentRouteSegment.slice(0, index + 1).join('/')}`)"
        >
          {{ routeVal }}
        </div>
        <span v-if="index !== currentRouteSegment.length - 1" class="text-gray-600">></span>
      </template>
    </h1>
  </div>
</template>
<script lang="ts" setup>
const route = useRoute();
const router = useRouter();
const currentRouteSegment = computed(() => route.path.split("/").filter((res) => res));
const caseStore = useCaseStore();

const onClickRoute = (route: string, url: string) => {
  if (route === "case") {
    caseStore.selectCase();
    router.push("/case");
    return;
  }

  router.push(url);
};
</script>
